import React from "react";

const Footer = () => (
  <footer className="bg-light p-3 text-center">
    <p>&copy; {new Date().getFullYear()} evoJets.</p>
  </footer>
);

export default Footer;
